import { isNotDev } from '../utils/isNotProd';

declare let gtag: any;

const analyticsLoaded = (): boolean => gtag !== undefined && !!gtag;

const prerequisites = (): boolean => isNotDev() && analyticsLoaded();

export abstract class AnalyticsService {
  public static pageview = (path: string) => {
    prerequisites() &&
      gtag('event', 'page_view', {
        page_location: path,
        page_path: path,
        page_title: path,
      });
  };

  public static event = (action: string, event_label: string, event_category: string, value?: number) => {
    prerequisites() &&
      gtag('event', action, {
        event_label,
        event_category,
        value,
      });
  };

  public static timing = (name: string, value: number, event_category?: string, event_label?: string) => {
    prerequisites() &&
      gtag('event', 'timing_complete', {
        name,
        value,
        event_category,
        event_label,
      });
  };
}
